module.exports = __webpack_public_path__ + "static/media/bandera_canada.f43953ba.png";